// @flow
import { GLOBAL_ERROR_THROW, GLOBAL_ERROR_CAUGHT } from "./action-types";

export const throwGlobalError = (error: any) => ({
  type: GLOBAL_ERROR_THROW,
  payload: error
});

export const catchGlobalError = (error: any) => ({
  type: GLOBAL_ERROR_CAUGHT,
  payload: error
});


// WEBPACK FOOTER //
// ./src/app/modules/errors/actions.js